import { ReactNode } from 'react';
import Dim from '@/components/common/Dim';
import { CloseWrap, Wrapper, Image } from '@/components/common/modal/DefaultModal.styled';
import { useDim } from '@/hooks';

interface IProps {
  children?: ReactNode;
  position?: string;
  setModalOpen: (modalOpen: boolean) => void;
}

const Modal = (props: IProps) => {
  const { children, position, setModalOpen } = props;
  const [, setIsUseDim] = useDim();

  const handleClickClose = () => {
    setModalOpen(false);
    setIsUseDim(false);
  };

  return (
    <Dim>
      <Wrapper position={position}>
        <CloseWrap>
          <Image src="/close.svg" alt="close" onClick={handleClickClose} loading="lazy" />
        </CloseWrap>
        <div>{children}</div>
      </Wrapper>
    </Dim>
  );
};
export default Modal;
